import NicoRobin from "../../assets/combatants/superpower/nico-robin.png";
import NicoRobinIcon from "../../assets/combatants/superpower/nico-robin-icon.png";
import NicoRobinWin from "../../assets/combatants/superpower/nico-robin-win.png";
import NicoRobinLose from "../../assets/combatants/superpower/nico-robin-lose.png";

import VinsmokeReiju from "../../assets/combatants/superpower/vinsmoke-reiju.png";
import VinsmokeReijuIcon from "../../assets/combatants/superpower/vinsmoke-reiju-icon.png";
import VinsmokeReijuWin from "../../assets/combatants/superpower/vinsmoke-reiju-win.png";
import VinsmokeReijuLose from "../../assets/combatants/superpower/vinsmoke-reiju-lose.png";

import BoaHancock from "../../assets/combatants/superpower/boa-hancock.png";
import BoaHancockIcon from "../../assets/combatants/superpower/boa-hancock-icon.png";
import BoaHancockWin from "../../assets/combatants/superpower/boa-hancock-win.png";
import BoaHancockLose from "../../assets/combatants/superpower/boa-hancock-lose.png";

import Nami from "../../assets/combatants/superpower/nami.png";
import NamiIcon from "../../assets/combatants/superpower/nami-icon.png";
import NamiWin from "../../assets/combatants/superpower/nami-win.png";
import NamiLose from "../../assets/combatants/superpower/nami-lose.png";

export const seriesId = "One Piece";

export default {
  nicoRobin: {
    seriesId,
    id: "nicoRobin",
    name: "Nico Robin",
    description:
      "Also known by her epithet 'Devil Child' and the 'Light of the Revolution', she is the archaeologist of the Straw Hat Pirates. She is the sole survivor of the destroyed island of Ohara.",
    img: NicoRobin,
    icon: NicoRobinIcon,
    opWinImg: NicoRobinWin,
    opLoseImg: NicoRobinLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "buxom",
    eyeColor: "blue",
    hairColor: "black",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 1,
    // Pref properties effect 'AI'
    prefAttack: "touch",
    prefTarget: "mouth",
    uniqueAttackText:
      "Nico pushes her heavy bust into xxxx's mouth, forcing her to taste her delicious breasts.",
    roughPlayLvl: -2, // how responds to domination either -hates or +likes
    // Prowess is capability
    seductionResistance: 25,
    grapplingProwess: 15,
    tongueProwess: 10,
    touchProwess: 25,
    cockProwess: 15,
    vaginaProwess: 20,
    anusProwess: 15,
    // -- resistance is ability to endure pleasure, 1 - 100
    touchResistance: 15,
    breastResistance: 10,
    mouthResistance: 20,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 10,
    orgasmLimit: 3,
  },
  vinsmokeReiju: {
    seriesId,
    id: "vinsmokeReiju",
    name: "Vinsmoke Reiju",
    description:
      "Also known as 'Poison Pink', is the eldest child and only daughter of the Vinsmoke Family. She is a princess of the Germa Kingdom and a commander in its military arm.",
    img: VinsmokeReiju,
    icon: VinsmokeReijuIcon,
    opWinImg: VinsmokeReijuWin,
    opLoseImg: VinsmokeReijuLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "blue",
    hairColor: "pink",
    skinColor: "fair",
    height: 3,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "touch",
    uniqueAttackText:
      "Reiju hungry licks xxxx's skin, covering them in saliva, and pleasuring their body.",
    roughPlayLvl: 15,
    seductionResistance: 25,
    grapplingProwess: 25,
    tongueProwess: 25,
    touchProwess: 5,
    cockProwess: 10,
    vaginaProwess: 20,
    anusProwess: 5,
    touchResistance: 5,
    breastResistance: 10,
    mouthResistance: 20,
    cockResistance: 5,
    vaginaResistance: 15,
    anusResistance: 5,
    orgasmLimit: 3,
  },
  boaHancock: {
    seriesId,
    id: "boaHancock",
    name: "Boa Hancock",
    description:
      "She is the current empress, known as the 'Snake Princess', of Amazon Lily and rules over the Kuja tribe.",
    img: BoaHancock,
    icon: BoaHancockIcon,
    opWinImg: BoaHancockWin,
    opLoseImg: BoaHancockLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "Buxom",
    eyeColor: "black",
    hairColor: "black",
    skinColor: "pale",
    height: 4,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 3,
    throatSize: 2,
    prefAttack: "touch",
    prefTarget: "touch",
    uniqueAttackText:
      "Hancock smothers her opponent with her shapely and tender breasts, tickled xxxx with her hard nipples.",
    roughPlayLvl: -15,
    seductionResistance: 25,
    grapplingProwess: 30,
    tongueProwess: 25,
    touchProwess: 30,
    cockProwess: 15,
    vaginaProwess: 25,
    anusProwess: 25,
    touchResistance: 15,
    breastResistance: 25,
    mouthResistance: 5,
    cockResistance: 15,
    vaginaResistance: 25,
    anusResistance: 15,
    orgasmLimit: 3,
  },
  nami: {
    seriesId,
    id: "nami",
    name: "Nami",
    description:
      "'Cat Burglar' Nami is the navigator of the Straw Hat Pirates. She is a capable thief, with tremenedous physical prowess.",
    img: Nami,
    icon: NamiIcon,
    opWinImg: NamiWin,
    opLoseImg: NamiLose,
    gender: "female",
    isWoman: true,
    hasCock: false,
    race: "Human",
    bodyShape: "busty",
    eyeColor: "brown",
    hairColor: "orange",
    skinColor: "fair",
    height: 2,
    penisSize: 0,
    breastSize: 4,
    vaginaSize: 2,
    anusSize: 2,
    throatSize: 1,
    prefAttack: "tongue",
    prefTarget: "cock",
    uniqueAttackText:
      "Nami impales herself on xxxx's cock, pushing it roughly into her throat, ignoring her gag reflex she deepthroats like a professional.",
    roughPlayLvl: 12,
    seductionResistance: 25,
    grapplingProwess: 30,
    tongueProwess: 40,
    touchProwess: 20,
    cockProwess: 15,
    vaginaProwess: 15,
    anusProwess: 25,
    touchResistance: 35,
    breastResistance: 25,
    mouthResistance: 35,
    cockResistance: 15,
    vaginaResistance: 10,
    anusResistance: 25,
    orgasmLimit: 3,
  },
};
